import { createContext } from "react";

import { DeleteClientRequest } from "@/types/request/DeleteClientRequest";

export interface ClientDeletionContextType {
  deleteClient: (request: DeleteClientRequest) => void;
  deletingClient: boolean;
  deleteSuccess: boolean;
  deleteError: boolean;
}

export const ClientDeletionContext = createContext<ClientDeletionContextType | null>(null);
